import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import { setSidebarToggle } from 'reducers/ThemeOptions';
import SidebarMainContent from 'layout-components/SidebarMainContent';

const LgDownSideBar = () => {
  const dispatch = useDispatch();
  const sidebarToggle = useSelector(state => state.ThemeOptions.sidebarToggle);

  const closeDrawer = () => dispatch(setSidebarToggle(true));

  return (
    <>
      {!sidebarToggle ? (
        <Drawer disablePortal anchor="left" open={true} onClose={closeDrawer} variant="temporary" elevation={4}>
          <SidebarMainContent />
        </Drawer>
      ) : null}
    </>
  );
};

export default LgDownSideBar;
